import { Typography } from '@material-ui/core';
import { navigate } from '@reach/router'
import { Button, Cards, Spinner, CustomIcon } from 'ams-ui-reactkit';
import React, { useEffect, useState } from 'react'
import { Dialog, SubTitleBlock, TitleBlock } from '../../../atoms';
import { TemplateProps } from '../../../journeys/journey/Interfaces';
import { AMSAccordion, DataBlock, IconsList } from '../../../molecules';
import { AddSignatureBlock, ItemBlock } from '../../../organisms';
import './MoveDetail.scss'
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from '../../../context';
import { calMoveChargesService } from '../../../graphql/getMoveChargesServicequery'
import { getPackMaterials } from '../../../graphql/getPackageMaterials.query'
import { getCustomerId, getRandomNumber } from '../../../utils/Utils';
import DynamicHtml from '../../../molecules/DynamicHtml';
import { actionTypeConstants } from '../../../utils';

const MoveDetail: React.FC<TemplateProps> = (props: any) => {

    const { templateProps } = props;
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const customerId = getCustomerId() || ""
    const signatures: any = useContextSelector(StoreContext, store => store?.appState?.signatures);
    let signUrl = signatures?.list?.find((s: any) => s.sequence === 1);
    const sign = signUrl?.getUrl || ""
    const acceptPaymentDetails: any = useContextSelector(StoreContext, store => (store?.appState?.customerInfo as any)?.acceptPayment) || [];

    const AgreeCheck: any = signatures?.moveDetails?.agreeCheck;

    const [enableCheckbox, SetEnableCheckBox] = useState(AgreeCheck || false)
    const [selectedData, SetSelectedData] = useState<any>(null)
    const [enableButton, setEnableButton] = useState(false);
    const [cantMovePopup, setCantMovepopup] = useState<any>("")
    const [loading, setLoading] = useState(false);
    const [popLoading, setPopLoading] = useState(false);

    useEffect(() => {
        (enableCheckbox) ? setEnableButton(true) : setEnableButton(false);
    }, [enableCheckbox])

    useEffect(() => {
        getMoveDetails()
    }, [])

    const getDataStructure = (data: any) => {
        let Arry = []
        if (data) {
            if (data?.moveDetails) {
                Arry.push(data?.moveDetails)
            }
            if (data?.chargesService) {
                Arry.push(data?.chargesService)
            }
            if (data?.estimateTypeBinding) {
                Arry.push(data?.estimateTypeBinding)
            }
        }
        return Arry
    }
    const getMoveDetails = async () => {
        setLoading(true)
        let respData = await calMoveChargesService(customerId)
        let dataStructure = getDataStructure(respData) || []
        if (respData) {
            dispatch({
                "type": actionTypeConstants.UPDATE_ACCEPT_PAYMENT_DETAILS,
                'payload': dataStructure
            })
        }
        setLoading(false)

    }

    const handleSignClick = (e: any) => {
        SetEnableCheckBox(!enableCheckbox)
        dispatch({
            type: actionTypeConstants.MOVE_DETAILS_ACCEPT_SIGN,
            payload: {
                status: !enableCheckbox
            }
        })
    }



    const handleSubItemClick = async (item: any) => {
        setLoading(true)
        setPopLoading(true)
        if (item.hasSubContent) {
            let respData = await getPackMaterials(customerId)
            if (respData) {
                SetSelectedData(respData)
            }
        }
        setLoading(false)
    }

    const handleClosePopup = () => {
        SetSelectedData(null)
        setPopLoading(false)
    }

    const onSignDone = () => {
        console.log("OnSignDone")
    }

    const handleClickOnItem = (data: any) => {
        setCantMovepopup(data)
    }

    const renderAccordion = () => {

        return selectedData?.section?.length ? <AMSAccordion list={selectedData?.section} /> : null

    }

    const renderDataBlock = () => {
        return (
            selectedData?.dataItems?.length || selectedData?.rowItems?.length ?
                <div className="itemBlockDiv">
                    <DataBlock key={1} {...selectedData} title="" variant={true} />
                </div>
                : null
        )
    }

    const renderSubtitle = () => {
        return !selectedData?.section?.length && !selectedData?.dataItems?.length ? <SubTitleBlock title="No Data Found" /> : null
    }

    return (
        <div className="baseContainerBlock">
            <div className="moveDetailTitle">
                {templateProps.title && <TitleBlock title={templateProps.title} />}
                <div className="paymentIcons">
                    <CustomIcon iconName="mastercard" />
                    <CustomIcon iconName="visa" />
                    <CustomIcon iconName="amex" />
                    <CustomIcon iconName="discover" />
                </div>
                {templateProps.subtitle && <SubTitleBlock title={templateProps.subtitle} />}
            </div>
            <Cards variant="default">
                <Typography variant="subtitle2" variantMapping={{ subtitle2: "div" }} className="fw-500 color-red">
                    {templateProps.transport.title}
                </Typography>
                <div>
                    <IconsList list={templateProps.transport.items} onClick={handleClickOnItem} />
                </div>
                <div className="mt-16">

                    <Typography variant="caption" variantMapping={{ caption: "div" }} className="lh-16 fw-900 color-red">
                        {templateProps.transport.itemsNote}
                    </Typography>
                    <Typography variant="subtitle2" variantMapping={{ subtitle2: "div" }} className="lh-16 mt-4 color-grey">
                        <DynamicHtml content={templateProps.transport.footerText} />
                    </Typography>
                </div>
            </Cards>
            <div className="moveDetailsInfo">
                {loading ? <div className="loader">
                    <Spinner />
                </div> : acceptPaymentDetails && acceptPaymentDetails.length > 0 && <Cards variant="default">
                    <div className="pl-16 pr-16 acceptPaymentDescription">
                        {acceptPaymentDetails.map((item: any, pageIndex: any) => <ItemBlock key={pageIndex + getRandomNumber()} {...item} onClickSubitem={handleSubItemClick} variant={true} />)}
                    </div>
                    {templateProps.signCard && <div className="moveDetailsSignCard">
                        <div className='mt-16'>
                            <AddSignatureBlock signature={sign} enable={enableCheckbox} onClick={handleSignClick} onEnd={onSignDone} />
                        </div>
                    </div>}
                </Cards>
                }
            </div>
            <div className="staticFixedButton">
                <Button
                    text={templateProps?.button}
                    onClick={() => { navigate(templateProps?.nextScreen || '/') }}
                    color="primary"
                    variant="contained"
                    size="large"
                    disabled={!enableButton}
                />
            </div>
            {cantMovePopup && <Dialog autoHeight={true} title={cantMovePopup?.title} open={true} handleClose={() => setCantMovepopup("")}>
                <div className="cantMovePopup">
                    <ul>
                        {cantMovePopup.items && cantMovePopup.items.map((item: any, pageIndex: any) => {
                            return <li key={pageIndex + getRandomNumber()} className='color-grey'>
                                {item}
                            </li>
                        })}
                    </ul>
                </div>
            </Dialog>}

            {popLoading && <Dialog title={selectedData?.title} open={true} fullwidth={true} handleClose={handleClosePopup}>
                {loading ? <div className="loader">
                    <Spinner />
                </div> :
                    <React.Fragment>
                        {renderAccordion()}
                        {renderDataBlock()}
                        {renderSubtitle()}
                    </React.Fragment>
                }
            </Dialog>}
        </div>
    )
}

export default MoveDetail
